import useBusinessPayments from "../hooks/use-business-payments";
import BusinessPaymentForm from "../features/business-payments/components/business-payment-form";
import { useState } from "react";
import { BusinessPaymentRequest } from "../service/model/business-payment.model";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import * as businesspaymentSlice from "../features/business-payments/business-payment.slice";
import Loader from "../components/loader";
import BusinessPaymentSummary from "../features/business-payments/components/business-payment-summary";
import BusinessPaymentTable from "../features/business-payments/components/business-payment-table";

const BusinessPayments = () => {
    const dispatch = useAppDispatch();
    const [showBusinessPaymentForm, setShowBusinessPaymentForm] = useState(false);
    const isLoading = useAppSelector(businesspaymentSlice.selectIsLoading);

    const [businesspayments] = useBusinessPayments();

    const handleSubmit = (data: BusinessPaymentRequest) => {
        dispatch(businesspaymentSlice.createBusinessPayment(data));
        setShowBusinessPaymentForm(false);
    };

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {businesspayments &&
                <>
                    <BusinessPaymentSummary />
                    <BusinessPaymentTable payments={businesspayments} />
                    {showBusinessPaymentForm &&
                        <BusinessPaymentForm payment={undefined} editable={true} onClose={() => setShowBusinessPaymentForm(false)} onSubmit={handleSubmit} />
                    }
                </>
            }
        </div>
    )
}

export default BusinessPayments;